import { createFileRoute } from "@tanstack/react-router"

import { DesktopDashboard } from "@/crm/components/dashboard/desktop/dashboard"
import { MobileDashboard } from "@/crm/components/dashboard/mobile/dashboard"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/")({
  component: DashboardRoute,
})

function DashboardRoute() {
  return <Adaptive desktop={<DesktopDashboard />} mobile={<MobileDashboard />} />
}
